var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })));
};
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAwQzguNTUyMjggMCA5IDAuNDQ3NzE1IDkgMVY3SDE1QzE1LjU1MjMgNyAxNiA3LjQ0NzcyIDE2IDhDMTYgOC41NTIyOCAxNS41NTIzIDkgMTUgOUg5VjE1QzkgMTUuNTUyMyA4LjU1MjI4IDE2IDggMTZDNy40NDc3MiAxNiA3IDE1LjU1MjMgNyAxNVY5SDFDMC40NDc3MTUgOSAwIDguNTUyMjggMCA4QzAgNy40NDc3MiAwLjQ0NzcxNSA3IDEgN0g3VjFDNyAwLjQ0NzcxNSA3LjQ0NzcyIDAgOCAwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";